export default {
	"dynamicReport": {
		"showWay": "展示方式",
		"beforeShow": "只显示前",
		"countData": "条数据",
		"dynamicreportTips": "只统计用户所属部门的数据",
		"dynamicreportWay": "汇总方式",
		"dynamicreportKeyOtherName": "统计字段别名",
		"enableRoles": "可查看角色",
		"enableUser": "可查看人员",
		"optionClickHandleTips": "请选可查看角色",
		"selectedValueOfTransferTips": "请选可查看人员",
		"statisticalField": "统计字段名称",
		"searchField": "字段查询",
		"groupfieldName": "分组字段名",
		"format": "格式",
		"dynamicreportKeyName": "统计字段名",
		"sortKey": "排序字段名",
		"sortingWay": "排序方式",
		"permissionsSet": "权限设置",
		"compositeKeys": "复合字段",
		"selectKey": "字段选择",
		"cancleDelete": "已取消删除",
		"searchTimeTips": "固定查询条件必须有时间字段且默认值不能为空",
		"keywordsNotEmptTips": "统计字段不能为空",
		"keyWordWayNotEmptTips": "统计字段汇总方式必选一个默认值",
		"fixedSearchKey": "固定查询条件"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/report/report.js